module.exports = __webpack_public_path__ + "images/processed-2x.png";


//////////////////
// WEBPACK FOOTER
// ./images/processed-2x.png
// module id = 1126
// module chunks = 1